import EcnounterList from './PeriodReports/EncounterList.json';
import PeriodReports from './PeriodReports/PeriodReports.json';
import TrapsDataList from './PeriodReports/TrapsDataList.json';
import VulnerabilityList from './PeriodReports/VulnerabilityList.json';
import SideBar from './SideBar/sideBar.json';
import topBar from './topBar.json';
import ClientsDashboard from './ClientsDashboard/ClientsDashboard.json';
import ClientsAccordion from './ClientsDashboard/ClientsAccordion.json';
import ClientTable from './ClientsDashboard/ClientTable.json';
import Modals from './ClientsDashboard/Modals.json';
import Pagination from './ClientsDashboard/Pagination.json';
import VisitReports from './VisitReports/VisitReports.json';
import DigestReport from './DigestReports/DigestReports.json';
import Monitoring from './VisitReports/Monitoring.json';
import UsedPoisons from './VisitReports/UsedPoisons.json';
import AddpoisonModal from './VisitReports/AddpoisonModal.json';
import VisitReportsPDF from './VisitReports/VisitReportsPDF.json';
import TrapTables from './Traps/Tables.json';
import ObjectNav from './Objects/ObjectNav.json';
import ViewModal from './Objects/ViewModal.json';
import TrapModals from './Traps/Modals.json';
import VisitReportsList from './VisitReports/VisitReportsList.json';
import DigestReportList from './DigestReports/DigestReportsList.json';
import DigestDeleteModal from './DigestReports/DigestReportsModal.json';
import MonitoringBait from './VisitReports/MonitoringBait.json';
import ObjectDocs from './ObjectDocs/ObjectDocs.json';
import ObjectVuls from './ObjectVuls/ObjectVuls.json';
import ObjectEncs from './ObjectEncs/ObjectEncs.json';
import PeriodReportList from './Reports/PeriodReportList.json';
import PaginationButtons from './Pagination/PaginationButtons.json';
import MCTDetail from './Traps/MCTDetail.json';
import PeriodReportPDF from './PeriodReports/PeriodReportPDF.json';
import MapSettings from './InteractiveMap/MapSettings.json';
import LocationSettings from './InteractiveMap/LocationSettings.json';
import MapLegend from './InteractiveMap/MapLegend.json';
import Popups from './InteractiveMap/Popups.json';
import MapModals from './InteractiveMap/MapModals.json';
import VulnerabilityModal from './InteractiveMap/VulnerabilityModal.json';
import PlanSelector from './InteractiveMap/PlanSelector.json';
import AddMenu from './InteractiveMap/AddMenu.json';
import ClientDashboardV2 from './ClientsDashboard/ClientDashboardV2.json';
import PopupButtonsArea from './ClientsDashboard/PopupButtonsArea.json';
import ActivityCard from './ClientsDashboard/ActivityCard.json';
import ClientSidebar from './ClientsDashboard/ClientSidebar.json';
import FilterDrawer from './ClientsDashboard/FilterDrawer.json';
import EmailNotifyModal from './ClientsDashboard/EmailNotifyModal.json';
import InteractiveMap from './InteractiveMap.json';
import ChartsAnalitics from './ObjectAnalitics/ChartsAnalitics.json';
import SBSDetail from './Traps/SBSDetail.json';
import HubDetail from './Traps/HubDetail.json';
import DeleteModal from './Users/DeleteModal.json';
import STDetail from './Traps/STDetail.json';
import DeviceWarehouse from './DeviceWarehouse/DeviceWarehouse.json';
import ForgotPassword from './ForgotPassword/ForgotPassword.json';
import AddSiteMap from './InteractiveMap/AddSiteMap.json';

export const enTranslation = {
  translation: {
    topBar,
    PeriodReports,
    EcnounterList,
    SideBar,
    TrapsDataList,
    VulnerabilityList,
    ClientsDashboard,
    ClientsAccordion,
    ClientTable,
    Modals,
    Pagination,
    VisitReports,
    DigestReport,
    Monitoring,
    UsedPoisons,
    AddpoisonModal,
    VisitReportsPDF,
    TrapTables,
    ObjectNav,
    ViewModal,
    TrapModals,
    VisitReportsList,
    DigestReportList,
    MonitoringBait,
    ObjectDocs,
    ObjectVuls,
    ObjectEncs,
    PeriodReportList,
    PaginationButtons,
    DigestDeleteModal,
    MCTDetail,
    STDetail,
    PeriodReportPDF,
    MapSettings,
    LocationSettings,
    MapLegend,
    Popups,
    MapModals,
    VulnerabilityModal,
    PlanSelector,
    AddMenu,
    ClientDashboardV2,
    PopupButtonsArea,
    ActivityCard,
    ClientSidebar,
    FilterDrawer,
    EmailNotifyModal,
    InteractiveMap,
    ChartsAnalitics,
    SBSDetail,
    HubDetail,
    DeviceWarehouse,
    AddSiteMap,
    ForgotPassword,
    DeleteModal,
  },
};
